import React from "react";
import { NextIsFree, NextIsPaid, NextIsAgainReadOnly, NextIsCancelled, NotImplementedSubscription } from "../../../Subscription/Components/CommonPanelContent";

interface Props {
  activeSubscription: server.dto.Subscription
  nextSubscriptionType: server.dto.SubscriptionType
  nextBillingCycle: server.dto.BillingCycle
}

const ReadOnlySubscription = (props: Props) => {
  switch (props.nextSubscriptionType.value) {
    case "free":
      return <NextIsFree {...props} />;
    case "paid":
      return <NextIsPaid {...props} />;
    case "readOnly":
      return <NextIsAgainReadOnly {...props} />;
    case "cancelledByClient":
    case "cancelledBySystemOne":
    case "trialEnd":
      return <NextIsCancelled {...props} />;
    default:
      return <NotImplementedSubscription />;
  }
};

export default ReadOnlySubscription;
